/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState, useContext, useRef } from "react";
import BiddingProcess_Hero from "../../../../icons/BiddingProcess_Hero";
import ExpertSupport_Hero from "../../../../icons/ExpertSupport_Hero";
import HomeIconSvg from "../../../../icons/HomeIconSvg";
import { Button } from "../../../../shadcn/components/ui/button";
import SearchComponent from "./SearchComponent";
import { Context, getSearchResults, getWatermarkedImgixUrl } from "services";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import useLocation from "../../../../hoc/useLocation";
import { AuthModalWrapper } from "../../Auth/AuthModal";
import { DisclaimerModal } from "./DisclaimerModal";

interface Locality {
  label: string;
  value: string;
}

const filterData = (dataToFilter: any) => {
  return (dataToFilter || []).map((data: any) => {
    let urlString = `auction-properties-in-${data.parent.locality_slug}-${data.parent.city_slug}`;
    return {
      label: data.parent.locality_name,
      value: urlString,
    };
  });
};

export default function Hero(props: any) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [localities, setLocalities] = useState<Locality[]>([]);
  const [cities, setCities] = useState<any>();
  const [defaultLocation, setDefaultLocation] = useState<any>();
  const { city } = useLocation(defaultLocation, cities);
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const [modalOpen, setModalOpen] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const isHovered = useRef<boolean>(false);
  const closeTimerRef = useRef<NodeJS.Timeout | null>(null);
  const init = async () => {
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          query_by: "",
          filter_by: `status:active && dump.location.city_name:${searchForm.value.city.label}`,
          filter: "true",
          facet_by: "dump.location.locality_slug",
          facet_return_parent: "dump.location.locality_slug",
          max_facet_values: "10000",
          per_page: 0,
        },
      ],
    });
    const localitiesData = filterData(
      data.results?.[0]?.facet_counts?.[0]?.counts || [],
    );
    setLocalities(localitiesData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, [searchForm.value.city]);

  const handleCities = async () => {
    const location: any = await getSearchResults({
      searches: [
        {
          q: "*",
          collection: "properties",
          facet: "dump.location.city_name",
          facet_by: "dump.location.city_name",
          facet_return_parent: "dump.location.city_name",
          max_facet_values: "5000",
          per_page: 0,
        },
      ],
    });

    const citiesData =
      location?.results?.[0]?.facet_counts?.[0]?.counts?.length > 0 &&
      location?.results?.[0]?.facet_counts?.[0]?.counts.map((item: any) => ({
        label: item.parent.city_name,
        value: item.parent.city_slug,
      }));

    setCities(citiesData);
    setDefaultLocation(
      location?.results?.[0]?.facet_counts?.[0]?.counts?.[0]?.parent ?? null,
    );
  };

  const handlePostYourPropertyClick = () => {
    if (isLoggedIn) window.open(`/post-your-property`, "_blank");
    else setModalOpen(true);
  };

  useEffect(() => {
    (async () => {
      await handleCities();
    })();
  }, []);

  useEffect(() => {
    if (city) {
      try {
        searchForm.setField("asset_type", {
          label: "Residential",
          value: "residential",
        });
        searchForm.setField("sub_asset_type", "");
        if (city) {
          searchForm.setField("city", {
            value: city.value,
            label: city.label,
          });
        }
        searchForm.setField("state", "");
        searchForm.setField("reserve_price", "");
        searchForm.setField("institutes", "");
        searchForm.setField("filter_by", "");
        searchForm.setField("sort_by", "");
      } catch (error) {
        console.log("error:::>", error);
      }
    }
  }, [city]);

  useEffect(() => {
    const openTimer = setTimeout(() => {
      showDisclaimerModal || setShowDisclaimerModal(true);

      closeTimerRef.current = setTimeout(() => {
        if (!isHovered.current) {
          setShowDisclaimerModal(false);
        }
      }, 10000);
    }, 10000);

    return () => {
      clearTimeout(openTimer);
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  const handleMouseEnter = () => {
    isHovered.current = true;
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
  };

  const handleMouseLeave = () => {
    isHovered.current = false;

    closeTimerRef.current = setTimeout(() => {
      setShowDisclaimerModal(false);
    }, 10000);
  };
  return (
    <>
      <div className="flex relative z-10">
        <div className="w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 mt-2 pt-2 pb-[42px] mid:pt-[38px] mid:pb-7 ">
          {/* Top component */}
          <div className=" mid:mt-0 mid:flex mid:w-full">
            <div className="pl-customPaddingMobile lg:pl-custom-100 flex flex-col justify-center   2xl:px-0 mr-8 ">
              <div className="">
                <p className="max-w-[535px]  tracking-tight font-spaceGrotesk font-bold text-mobile-h1 leading-10 md:text-[56px] md:leading-[60px] ">
                  Trusted Marketplace for Property Needs
                </p>
                <p className="font-spaceGrotesk font-bold text-mobile-h1 leading-10 md:text-[56px] md:leading-[60px]"></p>
                <p className="font-spaceGrotesk font-normal text-[20px] leading-[22px] text-brand-textGrey mt-4">
                  Bid | Buy | Borrow | Sell
                </p>
              </div>
              <div className="flex mt-2 mid:mt-[25px]">
                <div className="bg-brand-lightBlue flex items-center justify-end pl-1    pr-[6px] py-1 mid:py-0 mid:px-[17px] mid:h-10 ">
                  <BiddingProcess_Hero className="h-4 w-4 mid:h-[28px]  mid:w-[28px]" />
                  <p className="font-openSans font-normal text-brand-textBlack ml-1 text-mobile-body-xsm leading-3 md:ml-4 md:text-web-body-lg md:leading-6">
                    Transparent Bidding Process
                  </p>
                </div>
                <div className="bg-brand-lightBlue flex items-center justify-end ml-[9px] px-2 py-[5px]  mid:ml-7 mid:py-0 mid:px-[17px] mid:h-10 ">
                  <ExpertSupport_Hero className="h-4 w-4  mid:h-[28px] mid:w-[28px]" />
                  <p className="font-openSans font-normal text-brand-textBlack ml-1 text-mobile-body-xsm leading-3 md:ml-4 md:text-web-body-lg md:leading-6">
                    Expert Support
                  </p>
                </div>
              </div>
            </div>
            <div className="lg:px-custom-100 mid:pl-0  relative mt-[52px] w-full mid:mt-0 mid:w-auto  flex-1 2xl:px-0 ">
              <img
                src={getWatermarkedImgixUrl(
                  `${process?.env?.NEXT_PUBLIC_IMAGIX_URL_STATIC}/09dc3cad-ea46-4422-8d24-00176235c9f0`,
                )}
                alt="heroimage"
                className="lg:w-full w-screen shadow-hero-image 2xl:w-[800px]"
              />
            </div>
          </div>

          {/* Search Component */}
          <div className="px-customPaddingMobile lg:px-custom-100 2xl:px-customPadding 2xl:w-[1340px] 2xl:mx-auto  relative lg:mt-[30px] lg:mx-[100px] lg:h-[185px] mt-[47px]">
            <SearchComponent cities={cities} {...props} />
          </div>

          {/* Popular in City */}
          {localities.length > 0 && (
            <div className="px-customPaddingMobile lg:px-custom-100 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 hidden lg:flex w-full mt-6 justify-center">
              <p className="font-openSans font-normal text-brand-textGrey leading-4 text-web-body-lg">
                Popular in City
              </p>
              <ul className="flex pl-[10px] space-x-3 items-center">
                {localities.slice(0, 6).map((item: any) => (
                  <li key={item.value} className="flex items-center">
                    <Button
                      className="h-[22px] px-2 font-openSans capitalize font-normal text-[10px] leading-2 rounded-xl text-brand-textBlack"
                      variant="outline"
                      size={"custom"}
                      onClick={() => router.push(item.value)}
                    >
                      {item.label}
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {/* Post Your Property */}
          {process.env.NEXT_PUBLIC_PYP_ENABLE === "true" ? (
            <div className="flex justify-center items-center bg-[#EEEEEE] mt-[13px] mx-4  lg:mt-[56px] lg:w-[535px] lg:h-[61px] lg:mx-auto gap-4 py-4 mid:py-0 lg:rounded-lg">
              <HomeIconSvg className="w-5 h-5 lg:w-7 lg:h-7" />
              <div className="flex">
                <p className="font-openSans font-normal leading-4 text-brand-bgBlack text-mobile-body-sm lg:text-web-body-md">
                  List your property
                </p>
                <p
                  className="underline mx-1 md:mx-[6px] hover:cursor-pointer font-openSans font-normal leading-4 text-brand-orange text-mobile-body-sm lg:text-web-body-md"
                  onClick={handlePostYourPropertyClick}
                >
                  here
                </p>
                <p className="font-openSans font-normal leading-4 text-brand-bgBlack text-mobile-body-sm lg:text-web-body-md">
                  and let the offers roll in
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>{" "}
      </div>
      <AuthModalWrapper
        userLoggedin={isLoggedIn}
        authModelOpen={modalOpen}
        setAuthModelOpen={setModalOpen}
      />
      {showDisclaimerModal && (
        <DisclaimerModal
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          showDisclaimerModal={showDisclaimerModal}
          setShowDisclaimerModal={setShowDisclaimerModal}
        />
      )}
    </>
  );
}
